import OdataCoreServiceBase from "@/core/services/OdataCoreServiceBase";


class ClientContentMetricsService extends OdataCoreServiceBase {

    static code = "00B";
    code = "00B";

    constructor () {

        super({
            sourcePath: "client-content-metrics"
        });

    }

}

export default ClientContentMetricsService;
